/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'SafeStorage'

import SafeStorage from 'SafeStorage';
const USER_ATTRIBUTES_URI = `users/v1/app/attributes`;
const ONBOARDING_SETTINGS_URI = `onboarding-settings/v1/user-guide-enrollment`;
const ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY = 'GrowthOnboarding:IsEnrolledInGettingStarted';

const getUserAttributesUrl = hubletOriginOverride => {
  if (!hubletOriginOverride) {
    return USER_ATTRIBUTES_URI;
  }

  if (!hubletOriginOverride.endsWith('/')) {
    hubletOriginOverride = `${hubletOriginOverride}/`;
  }

  return `${hubletOriginOverride}${USER_ATTRIBUTES_URI}`;
};

export function getGSEnrollmentUserAttributeKey(portalId = PortalIdParser.get()) {
  return `GrowthOnboarding:ShouldSeeNewOnboarding:${portalId}`;
}

function changeEnrollment(isEnrolled, userId, portalId, options = {}) {
  // dual writing to Onboarding Settings and UserAttributes API
  return Promise.all([changeEnrollmentOnboardingSettings(isEnrolled), changeEnrollmentUserAttributes(isEnrolled, userId, portalId, options)]);
}

function changeEnrollmentOnboardingSettings(isEnrolled) {
  return http.put(ONBOARDING_SETTINGS_URI, {
    data: {
      enrolledInUserGuide: isEnrolled
    }
  });
}

function changeEnrollmentUserAttributes(isEnrolled, userId, portalId, options = {}) {
  const {
    hubletOriginOverride
  } = options;
  return http.post(getUserAttributesUrl(hubletOriginOverride), {
    data: {
      userId,
      key: getGSEnrollmentUserAttributeKey(portalId),
      value: isEnrolled,
      enrolledInUserGuide: isEnrolled
    }
  });
}

export function unenrollInGettingStarted(userId, portalId) {
  return changeEnrollment(false, userId, portalId);
}
export function enrollInGettingStarted(userId, portalId, options) {
  return changeEnrollment(true, userId, portalId, options);
}
export function unenrollInGettingStartedLocally() {
  SafeStorage.removeItem(ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY);
}
export function enrollInGettingStartedLocally() {
  SafeStorage.setItem(ONBOARDING_ENROLLED_LOCAL_STORAGE_KEY, Date.now());
}
export function isEnrollParamPresent() {
  return window.location.search.indexOf('enroll=true') >= 0;
}
export function isUserEnrolledInGettingStarted(portalId) {
  return http.get(USER_ATTRIBUTES_URI, {
    query: {
      key: getGSEnrollmentUserAttributeKey(portalId)
    }
  }).then(({
    attributes
  }) => {
    if (!attributes || attributes.length === 0) {
      return false;
    }

    const [enrollmentAttribute] = attributes;
    return enrollmentAttribute.value === 'true';
  });
}